import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class AuthService {
    getToken() {
        return localStorage.getItem("auth_token");
    }
    getUser() {
        return JSON.parse(<string>localStorage.getItem("auth_user_crocs"));
    }
    isGuest() {
        return this.getUser()?.is_guest;
    }
}
